import { createSlice } from "@reduxjs/toolkit";
import * as approvalService from "services/approvalService";
import { ListViewOption } from "core/components/listToggle/listToggleControl";
import { WipFilterModel } from "core/models/WipFilterModel";
import { logger } from "utils/logger";
import * as styleService from "services/styleService";
import { AnnotationModel, MediaFilterModel } from "core/models";
import ResultSet from "core/models/ResultSet";
import { updateCaptureItems } from "utils/helper";
import { updateCapture } from "services/approvalService";

const approvalSlice = createSlice({
  name: "approvalSlice",
  initialState: {
    wips: new ResultSet(),
    selectedWip: null,
    selectedStyles: [],
    displayPrefs: { mediaDisplayType: ListViewOption.GRID },
    wipFilter: { ...new WipFilterModel(), groupBy: "Dept" },
    styleFilter: { ...new WipFilterModel() },
    styleMediaFilter: { ...new MediaFilterModel() },
    styles: new ResultSet(),
    report: new ResultSet(),
    productionWipList: new ResultSet(),
    productionWipFilter: { ...new WipFilterModel(), groupBy: "" },

    postProductionWipList: new ResultSet(),
    postProductionWipFilter: { ...new WipFilterModel(), groupBy: "" },

    selectedStyle: null,
    selectedTasks: [],
    selectedTask: null,
    taskItemFilter: { ...new MediaFilterModel(),hasAnnotations: -1 },
    // standard props
    error: null,
    success: null,
    loading: false,
    action: null,
  },
  reducers: {
    setDisplayPrefs(state, action) {
      state.displayPrefs = { ...action.payload };
    },
    selectStyle(state, action) {
      logger.log("Setting Style: ", action.payload);
      state.selectedStyle = action.payload ? { ...action.payload } : null;
    },
    selectStyles(state, action) {
      logger.log("setting selected wips", action.payload);
      state.selectedStyles = action.payload ? [...action.payload] : [];
    },

    selectTask(state, action) {
      logger.log("Setting Task: ", action.payload);
      state.selectedTask = action.payload ? { ...action.payload } : null;
    },
    selectTasks(state, action) {
      logger.log("setting selected wips", action.payload);
      state.selectedTasks = action.payload ? [...action.payload] : [];
    },

    setWipFilter(state, action) {
      logger.log("Setting Wip: ", action.payload);
      state.wipFilter = action.payload ? { ...action.payload } : null;
    },
    setProductionWipFilter(state, action) {
      logger.log("Setting Production Wip Filter: ", action.payload);
      state.productionWipFilter = action.payload ? { ...action.payload } : null;
    },
    setStyleFilter(state, action) {
      logger.log("Setting Style Filter: ", action.payload);
      state.styleFilter = action.payload ? { ...action.payload } : null;
    },
    setStyleMediaFilter(state, action) {
      logger.log("Setting Style Filter: ", action.payload);
      state.styleMediaFilter = action.payload ? { ...action.payload } : null;
    },
    selectTask(state, action) {
      logger.log("Setting Task: ", action.payload);
      state.selectedTask = action.payload ? { ...action.payload } : null;
    },
    setTaskItemFilter(state, action) {
      logger.log("Setting Task Item Filter: ", action.payload);
      state.taskItemFilter = action.payload ? { ...action.payload } : null;
    },

    setPostProductionWipFilter(state, action) {
      logger.log("Setting Post Production Wip Filter: ", action.payload);
      state.postProductionWipFilter = action.payload
        ? { ...action.payload }
        : null;
    },

    setError(state, action) {
      state.error = action.payload;
    },
    //////////////////////
    //
    // GET STYLES
    //
    //////////////////////
    getWipsStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getWipsSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Wips Success" };

      state.wips = {
        ...state.wips,
        [action.payload.id]: {
          data: action.payload.data,
          timestamp: action.payload.timestamp,
        },
      };
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getWipsFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    //////////////////////
    //
    // GET STYLES
    //
    //////////////////////
    getStylesStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getScheduleSuccess(state, action) {
      logger.log("getSchudule : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Styles Success" };

      // state.styles = [...action.payload];
      state.styles = {
        ...state.styles,
        ...action.payload,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getScheduleFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    //////////////////////
    //
    // GET APPROVAL SELECTS
    //
    //////////////////////
    getApprovalSelectsSuccess(state, action) {
      logger.log("getApprovalSelects : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Approval Selects Success",
      };

      // state.styles = [...action.payload];
      state.productionWipList = {
        ...state.styles,
        ...action.payload,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getApprovalSelectsFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    getApprovalStyleCapturesSuccess(state, action) {
      logger.log("getApprovalSelects : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Approval Selects Success",
      };

      // state.styles = [...action.payload];
      // state.styles = {
      //   ...state.styles,
      //   ...action.payload,
      // };

      state.selectedStyle = {
        ...state.selectedStyle,
        assets: action.payload.data,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getApprovalStyleCapturesFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    setSessionCapturesSuccess(state, action) {
      logger.log(action.type, " : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Captures successfully updated",
      };

      // update the captures
      const captures = [
        ...updateCaptureItems(state.selectedStyle.assets, action.payload),
      ];
      state.selectedStyle = { ...state.selectedStyle, assets: captures };
      state.error = null;
    },

    //////////////////////
    //
    // GET POST PRODUCTION TASKS
    //
    //////////////////////
    getPostProdTasksSuccess(state, action) {
      logger.log("getPostProductionTasks : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Post Production Tasks Success",
      };

      // state.styles = [...action.payload];
      state.postProductionWipList = {
        ...state.styles,
        ...action.payload,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getPostProdTasksFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    getPostProdCapturesSuccess(state, action) {
      logger.log("getApprovalSelects : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Approval Selects Success",
      };

      // state.styles = [...action.payload];
      // state.styles = {
      //   ...state.styles,
      //   ...action.payload,
      // };

      state.selectedStyle = {
        ...state.selectedStyle,
        assets: action.payload.data,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getApprovalStyleCapturesFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    setSessionCapturesSuccess(state, action) {
      logger.log(action.type, " : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Captures successfully updated",
      };

      // update the captures
      const captures = [
        ...updateCaptureItems(state.selectedStyle.assets, action.payload),
      ];
      state.selectedStyle = { ...state.selectedStyle, assets: captures };
      state.error = null;
    },

    //////////////////////
    //
    // GET REPORT
    //
    //////////////////////
    getReportStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getReportSuccess(state, action) {
      logger.log("getSchudule : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Styles Success" };

      // state.styles = [...action.payload];
      state.report = {
        ...state.report,
        ...action.payload,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getReportFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    //////////////////////
    //
    // SINGLE STYLE
    //
    //////////////////////
    getStyleStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getStyleSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Wip Success",
        data: action.payload,
      };
      // if(action.payload.urls){
      //   state.selectedProject = {...state.selectedProject, urls:action.payload.urls}
      // }
      state.selectedStyle = action.payload ? { ...action.payload } : null;
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getWipAssetsSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Wips Assets Success" };

      state.selectedWip = { ...state.selectedWip, assets: action.payload };
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getStyleFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    getWipScansSuccess(state, action) {
      logger.log("getWipScansSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Wip Scans Success" };

      state.selectedWip = { ...state.selectedWip, scans: action.payload };
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getWipTimelineSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Wip Timeline Success",
      };

      if (state.selectedWip) {
        state.selectedWip = {
          ...state.selectedWip,
          timeline: action.payload.Timeline,
        };
      }
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    updateWipAssetSuccess(state, action) {
      logger.log("updateWipSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Update Wip Success" };
      // state.selectedWip = { ...action.payload };
      state.error = null;
    },
    udpateWipAssetFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    batchUpdateWipAssetSuccess(state, action) {
      state.loading = false;
      state.success = {
        type: action.type,
        message: "Updated Wips Successfully",
      };
      // state.selectedWip = { ...action.payload };
      state.error = null;
    },

    distributeWipsSuccess(state, action) {
      logger.log("updateWipSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Update Wip Success" };

      // update the wips status for distributed items
      const tmpWips = [...state.wips].map((item) => {
        const match = action.payload.find((id) => id === item.id);
        if (match) {
          return {
            ...item,
            // status:SampleStatusTypes.SAMPLE_DISTRIBUTED
          };
        } else {
          return item;
        }
      });

      state.wips = [...tmpWips];
      state.error = null;
    },
    distributeWipsFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    //////////////////////
    //
    // GET TASK
    //
    //////////////////////
    getTaskSuccess(state, action) {
      logger.log("getTaskSuccess : SUCCESS");
      state.loading = false;
      state.success = { type: action.type, message: "Task Fetched" };
      state.selectedTask = action.payload ? { ...action.payload } : null;
    },
    getTaskFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },
    //////////////////////
    //
    // MARKUPS
    //
    //////////////////////
    getMarkupsSuccess(state, action) {
      logger.log("getMarkupsSuccess : SUCCESS", action.payload.data);

      state.loading = false;
      state.success = { type: action.type, message: "Markups Fetched" };

      // find the task's item and set it's annotations.
      var items = [...state.selectedTask.items];

      // loop over the payload items and set the annotations.
      action.payload.data.forEach((annotation) => {
        const idx = annotation.payload.sequence;
        logger.log(idx, "idx");
        var item = items[idx];
        if(item){
          if(!item.annotations){
            item.annotations = [];
          }
          item.annotations.push(annotation);
        }
      });

      state.selectedTask = { ...state.selectedTask, items: items };
      // var item = items.find((val) => val.id === action.payload.id);


      // if(item){
      //   item.annotations = [...action.payload.data];
      // }
      // var capture = state.captures.find((val) => val.id === action.payload.id);
      // const captureIdx = state.captures.indexOf(capture);

      // if (capture) {
      //   capture.annotations = [...action.payload.data];
      // }
      // const tmpCaptures = [...state.captures];
      // state.captures = [...updateCaptureItems(tmpCaptures, [capture])];

      // // update the selected item
      // if (state.selectedItem && captureIdx > -1) {
      //   // state.selectedItem = setObjectFromProps(state.selectedItem,capture);
      // }

      // state.scans = [...action.payload];
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    setMarkupSuccess(state, action) {
      logger.log("setMarkupSuccess : SUCCESS");
      const {image,markup} = action.payload;
      state.loading = false;
      
      // Create a proper deep copy to ensure new references
      var task = { 
        ...state.selectedTask,
        items: state.selectedTask.items.map(item => ({
          ...item,
          annotations: item.annotations ? [...item.annotations] : []
        }))
      };
      
      const itemIndex = task.items.findIndex((item) => item.actionSort === image.actionSort);

      if(itemIndex > -1){
        // Ensure annotations array exists
        if (!task.items[itemIndex].annotations) {
          task.items[itemIndex].annotations = [];
        }
        
        // Create a new annotations array to ensure reference change
        const annotations = [...task.items[itemIndex].annotations];
        
        // find the annotation with the same id as the markup
        const annotationIndex = annotations.findIndex((annotation) => 
          annotation.payload?.markup?.id === markup.id || annotation.payload?.id === markup.id
        );
        
        if(annotationIndex > -1){
          // Update existing annotation - create new object with new reference
          annotations[annotationIndex] = {
            ...annotations[annotationIndex],
            payload: markup
          };
        }else{
          // Add new annotation
          const {annPart,annSort,ts,user,id} = markup;
          var newAnnotation = new AnnotationModel({annPart,annSort,ts,user,id});
          newAnnotation.id = markup.id;
          newAnnotation.payload = markup;
          annotations.push(newAnnotation);
        }
        
        // Create new item with new annotations array reference
        task.items[itemIndex] = {
          ...task.items[itemIndex],
          annotations: annotations
        };
      }
      
      // Create new items array with new reference
      state.selectedTask = {
        ...task,
        items: task.items
      };
      
      state.success = { type: action.type, message: "Markups Updated" };
      state.error = null;
    },

    deleteMarkupSuccess(state, action) {
      logger.log("deleteMarkupSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Markup Removed" };

      state.error = null;
    },

    updatePostProductionTaskSuccess(state, action) {
      logger.log("updatePostProductionTaskSuccess : SUCCESS");
      state.loading = false;
      state.success = { type: action.type, message: "Post Production Task Updated" };
      state.error = null;
    },

    updatePostProductionTaskFailure(state, action) {
      logger.log("updatePostProductionTaskFailure : FAIL");
      state.loading = false;
      state.error = action.payload;
    },

    clearNotifications(state, action) {
      state.error = null;
      state.success = null;
    },

    onServiceStart(state, action) {
      state.success = null;
      state.loading = true;
      state.error = null;
      // state.action = action.type;
    },
    onServiceFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
      state.loading = false;
    },
  },
});

// STYLES
export const fetchSchedule = (criteria) => async (dispatch) => {
  try {
    dispatch(getStylesStart());

    // const currentTime = Date.now();
    // if (state.styles.data && (currentTime - state.styles.timestamp) < 3600000) {
    //   // return cachedItem.data;
    // }

    const data = await styleService.getSchedule(criteria);
    const result = new ResultSet(
      data,
      JSON.stringify(criteria),
      new Date(),
      "schedule"
    );
    dispatch(getScheduleSuccess(result));
  } catch (err) {
    logger.log("err", err);
    dispatch(getScheduleFailure(err));
  }
};

export const fetchReport = (criteria) => async (dispatch) => {
  try {
    dispatch(getReportStart());

    // const currentTime = Date.now();
    // if (state.styles.data && (currentTime - state.styles.timestamp) < 3600000) {
    //   // return cachedItem.data;
    // }

    const data = await styleService.getReport(criteria);
    const result = new ResultSet(
      data,
      JSON.stringify(criteria),
      new Date(),
      "report"
    );
    dispatch(getReportSuccess(result));
  } catch (err) {
    logger.log("err", err);
    dispatch(getReportFailure(err));
  }
};

export const fetchStyle = (id) => async (dispatch) => {
  try {
    dispatch(getStyleStart());
    // const data = await getStyleTimeline({ id: criteria.keyword });
    const data = await styleService.getStyle(id);
    dispatch(getStyleSuccess(data));
  } catch (err) {
    logger.log("err", err);
    dispatch(getStyleFailure(err));
  }
};

export const fetchStyleMeta =
  (sessionCode, styleNumber) => async (dispatch) => {
    try {
      dispatch(getStyleStart());
      // const data = await getStyleTimeline({ id: criteria.keyword });
      const data = await approvalService.getStyleMeta(sessionCode, styleNumber);
      dispatch(getStyleSuccess(data));
    } catch (err) {
      logger.log("err", err);
      dispatch(getStyleFailure(err));
    }
  };

export const fetchApprovalSelects = (criteria) => async (dispatch) => {
  try {
    dispatch(getStylesStart());

    // const currentTime = Date.now();
    // if (state.styles.data && (currentTime - state.styles.timestamp) < 3600000) {
    //   // return cachedItem.data;
    // }

    const data = await approvalService.getSelects(criteria);
    const result = new ResultSet(
      data,
      JSON.stringify(criteria),
      new Date(),
      "approvalSelects"
    );
    dispatch(getApprovalSelectsSuccess(result));
  } catch (err) {
    logger.log("err", err);
    dispatch(getApprovalSelectsFailure(err));
  }
};

export const fetchApprovalStyleCaptures = (criteria) => async (dispatch) => {
  try {
    dispatch(getStylesStart());

    // const currentTime = Date.now();
    // if (state.styles.data && (currentTime - state.styles.timestamp) < 3600000) {
    //   // return cachedItem.data;
    // }

    const data = await approvalService.getStyleCaptures(criteria);
    const result = new ResultSet(data, JSON.stringify(criteria), new Date());
    dispatch(getApprovalStyleCapturesSuccess(result));
  } catch (err) {
    logger.log("err", err);
    dispatch(getApprovalStyleCapturesFailure(err));
  }
};

export const fetchPostProductionTasks = (criteria) => async (dispatch) => {
  try {
    const data = await approvalService.getPostProductionTasks(criteria);
    const result = new ResultSet(
      data,
      JSON.stringify(criteria),
      new Date(),
      "postProductionTasks"
    );
    dispatch(getPostProdTasksSuccess(result));
  } catch (err) {
    logger.log("err", err);
    dispatch(getPostProdTasksFailure(err));
  }
};

export const setSessionCaptures = (captures, user) => async (dispatch) => {
  try {
    logger.log(captures, " SETTING CAPTURES");
    dispatch(onServiceStart());
    dispatch(setSessionCapturesSuccess(captures));

    for (let i = 0; i < captures.length; i++) {
      const capture = captures[i];
      await updateCapture(capture);
    }
    //dispatch(setSessionCapturesSuccess(captures))
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};

export const updateStudioSessionStyle = (style, user) => async (dispatch) => {
  try {
    logger.log(style, " SETTING STYLE");
    dispatch(onServiceStart());

    await approvalService.updateSessionStyle(style);

    //dispatch(setSessionCapturesSuccess(captures))
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};

export const updateStudioSession = (session, user) => async (dispatch) => {
  try {
    dispatch(onServiceStart());

    await approvalService.updateSession(session);

    //dispatch(setSessionCapturesSuccess(captures))
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};

//////////////////
// MARKUPS
//////////////////


export const fetchTaskMeta = (taskPart, taskSort) => async (dispatch) => {
  try {
    dispatch(getStyleStart());
    // const data = await getStyleTimeline({ id: criteria.keyword });
    const data = await approvalService.getTaskMeta(taskPart, taskSort);
    dispatch(getTaskSuccess(data));
  } catch (err) {
    logger.log("err", err);
    dispatch(getTaskFailure(err));
  }
};


export const fetchMarkups = (id, criteria, user) => async (dispatch) => {
  try {
    dispatch(onServiceStart());
    const data = await approvalService.getMarkups(
      id,
      criteria
    );
    dispatch(getMarkupsSuccess({ id, data }));
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};
export const setMarkup = (image, markup, user) => async (dispatch) => {
  try {
    dispatch(onServiceStart());
    dispatch(setMarkupSuccess({image,markup}));

    return;
    const data = await approvalService.udpateMarkup(
      image,
      markup,
      user ? user.rawIdToken : ""
    );
    
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};

export const deleteMarkup = (id, markup, user) => async (dispatch) => {
  try {
    dispatch(onServiceStart());
    const data = await approvalService.removeMarkup(
      id,
      markup,
      user ? user.rawIdToken : ""
    );
    dispatch(deleteMarkupSuccess(data));
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};


export const updatePostProductionTask = (task, user) => async (dispatch) => {
  try {
    dispatch(onServiceStart());
    logger.log(task, "UPDATING POST PRODUCTION TASK");
    const data = await approvalService.updatePostProductionTask(task);
    dispatch(updatePostProductionTaskSuccess(task));
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};
export const {
  // selectWip,
  selectStyles,
  setWipFilter,
  setProductionWipFilter,
  setPostProductionWipFilter,
  setStyleFilter,
  setDisplayPrefs,
  selectStyle,
  selectTask,
  selectTasks,
  setTaskItemFilter,

  updatePostProductionTaskSuccess,
  updatePostProductionTaskFailure,

  styleMediaFilter,
  setStyleMediaFilter,

  getWipStart,
  getWipFailure,
  getWipSuccess,

  getWipAssetsSuccess,

  getWipScansSuccess,

  getWipTimelineSuccess,

  getStylesStart,
  getScheduleSuccess,
  getScheduleFailure,

  getApprovalSelectsSuccess,
  getApprovalSelectsFailure,

  getApprovalStyleCapturesSuccess,
  getApprovalStyleCapturesFailure,

  setSessionCapturesSuccess,

  getPostProdTasksSuccess,
  getPostProdTasksFailure,

  getReportStart,
  getReportSuccess,
  getReportFailure,

  getStyleStart,
  getStyleSuccess,
  getStyleFailure,

  getWipsStart,
  getWipsFailure,
  getWipsSuccess,

  onServiceStart,
  onServiceFailure,

  updateWipAssetSuccess,
  updateWipAssetFailure,

  batchUpdateWipAssetSuccess,

  distributeWipsSuccess,
  distributeWipsFailure,

  getMarkupsSuccess,
  getTaskSuccess,
  getTaskFailure,
  setMarkupSuccess,
  deleteMarkupSuccess,


  clearNotifications,
  setError,
} = approvalSlice.actions;

export default approvalSlice.reducer;
